module.exports = __webpack_public_path__ + "static/img/compute-success.b87d9ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/compute-success.png
// module id = 4kot
// module chunks = 1